var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOutlook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.241,
    height: 24.602,
    viewBox: "0 0 26.241 24.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outlook",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M268.3,112.011H256.82a.82.82,0,0,0,0,1.64h9.091l-5.038,3.918-3.613-2.3-.879,1.384,4.1,2.608a.821.821,0,0,0,.943-.044l6.056-4.712v10.624H256.82a.82.82,0,1,0,0,1.64H268.3a.821.821,0,0,0,.82-.82V112.831A.821.821,0,0,0,268.3,112.011Z",
    transform: "translate(-242.88 -107.089)",
    fill: "#1976d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M14.463,16.179A.806.806,0,0,0,13.789,16L.67,18.465a.818.818,0,0,0-.67.806V37.31a.819.819,0,0,0,.67.8l13.12,2.46a.771.771,0,0,0,.151.015.82.82,0,0,0,.82-.82V16.81a.818.818,0,0,0-.3-.632Z",
    transform: "translate(0 -15.988)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M68.1,185.85c-2.26,0-4.1-2.207-4.1-4.92s1.84-4.92,4.1-4.92,4.1,2.207,4.1,4.92S70.36,185.85,68.1,185.85Zm0-8.2c-1.357,0-2.46,1.471-2.46,3.28s1.1,3.28,2.46,3.28,2.46-1.471,2.46-3.28-1.1-3.279-2.46-3.279Z",
    transform: "translate(-60.72 -167.808)",
    fill: "#fafafa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlook);
export default __webpack_public_path__ + "static/media/icon-outlook.77315097d6015800af41ebd733dae992.svg";
export { ForwardRef as ReactComponent };